import api from "api";
import { useMutation } from "react-query";

export interface InviteBillingAdminInput {
  email: string;
  phone_number?: string;
  phone_country_code?: string;
  first_name: string;
  last_name: string;
  health_care_organization_id: number;
  country: string;
  timezone: string;
}

export interface InviteBillingAdminResponse {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
}

const useInviteBillingAdmin = () =>
  useMutation(async (data: InviteBillingAdminInput) => {
    const response = await api.call("/invitations/billing_admin", {
      method: "POST",
      data,
    });
    return response.json() as Promise<InviteBillingAdminResponse>;
  });

export default useInviteBillingAdmin;
